var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.943,6.813,14.19,2.182a.746.746,0,0,0-.523-.213H5.58a.75.75,0,0,0-.75.75V21.281a.75.75,0,0,0,.75.75H18.42a.75.75,0,0,0,.75-.75V7.35A.75.75,0,0,0,18.943,6.813ZM17.6,7.6l-3.98.013V3.724ZM6.33,20.531V3.469h5.794v4.9a.751.751,0,0,0,.75.75h0L17.67,9.1V20.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.708,13.375H8.292a.75.75,0,0,0,0,1.5h7.416a.75.75,0,1,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.708,16.258H8.292a.75.75,0,1,0,0,1.5h7.416a.75.75,0,1,0,0-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.2c9f559e2d804f0a7764c8768c86c452.svg";
export { ForwardRef as ReactComponent };